<div id="notifications-container">
  <div id="notifications-inner-container">
    @for (notificationData of NotificationService.NotificationComponents(); track notificationData.uniqueId){
      <app-notification 
        [Message]=notificationData.message
        [DisplayTime]=notificationData.displayTimeInMs
        [VisualType]="notificationData.visualType"
        (OnClosingAnimationFinished)="OnNotificationCloseAnimationFinished(notificationData.uniqueId)"
        ></app-notification>
    }
  </div>
</div>